import { useEffect, useState } from 'react';
import { fetchTrialState } from 'purchase-motions-api/query/trials';
import Products from 'merchandise-lib/constants/Product';

// This is a map of trial products that conflict with each other.
// If the user has a trial of one of these products, they cannot activate a trial of the other.
// For example, if the user has a trial of MARKETING_PLUS_ENTERPRISE, they cannot activate a trial of CMS_ENTERPRISE or MARKETING_ENTERPRISE.
const conflictingTrialsMap = {
  [Products.MARKETING_PLUS_SUITE_BUNDLE_ENTERPRISE]: [Products.MARKETING_HUB_ENTERPRISE, Products.CMS_HUB_ENTERPRISE],
  [Products.MARKETING_PLUS_SUITE_BUNDLE_PROFESSIONAL]: [Products.MARKETING_HUB_PROFESSIONAL, Products.CMS_HUB_PROFESSIONAL],
  [Products.MARKETING_HUB_PROFESSIONAL]: [Products.MARKETING_PLUS_SUITE_BUNDLE_PROFESSIONAL],
  [Products.MARKETING_HUB_ENTERPRISE]: [Products.MARKETING_PLUS_SUITE_BUNDLE_ENTERPRISE],
  [Products.CMS_HUB_PROFESSIONAL]: [Products.MARKETING_PLUS_SUITE_BUNDLE_PROFESSIONAL],
  [Products.CMS_HUB_ENTERPRISE]: [Products.MARKETING_PLUS_SUITE_BUNDLE_ENTERPRISE]
};
export const useTrialState = apiName => {
  var _data$activeTrials, _data$expiredTrials;
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [data, setData] = useState();
  useEffect(() => {
    fetchTrialState().then(response => {
      setData(response);
      setLoading(false);
    }).catch(e => {
      setError(e);
      setLoading(false);
    });
  }, []);
  const activeTrials = (_data$activeTrials = data === null || data === void 0 ? void 0 : data.activeTrials) !== null && _data$activeTrials !== void 0 ? _data$activeTrials : new Set();
  const expiredTrials = (_data$expiredTrials = data === null || data === void 0 ? void 0 : data.expiredTrials) !== null && _data$expiredTrials !== void 0 ? _data$expiredTrials : new Set();
  const conflictingTrials = [...activeTrials].filter(trial => {
    var _conflictingTrialsMap;
    return trial === apiName || ((_conflictingTrialsMap = conflictingTrialsMap[trial]) === null || _conflictingTrialsMap === void 0 ? void 0 : _conflictingTrialsMap.includes(apiName));
  }).concat([...expiredTrials].filter(trial => trial === apiName));
  return {
    loading,
    error,
    trialState: {
      activeTrials,
      expiredTrials,
      conflictingTrials
    }
  };
};